/// <reference path='../../../../typings/index.d.ts' />
/// <reference path='../../components/models/meevo.model.custom.ts' />
/// <reference path='employeeSupplyUsage.module.ts' />
///<reference path="../../components/short-cuts/models/short-cuts-state-manager.controller.ts"/>


module Meevo.Plugins.EmployeeSupplyUsage {
    import PresetStatus = Meevo.Components.Controls.PresetStatus;
    import ISupplyUsageLineItem = Meevo.Model.ISupplyUsageLineItem;
    import Variant = Meevo.Model.Variant;
    import VariantUsage = Meevo.Model.VariantUsageSetting;
    import EmployeeListItem = Meevo.Model.EmployeeListItem;
    import ChangedDateEnum = Meevo.Components.Controls.ChangedDateEnum;
    import ProductInventoryTypeEnum = Meevo.Model.ProductInventoryTypeEnum;
    import InventoryCountLineItems = Meevo.Model.InventoryCountLineItems;
    import Promise = Q.Promise;
    import ShortCutsStateManagerController = Meevo.Components.ShortCuts.ShortCutsStateManagerController;
    import ShortCutGroup = Meevo.Components.ShortCuts.ShortCutGroup;
    import IShortCutGroup = Meevo.Components.ShortCuts.IShortCutGroup;
    import ProductUsageAmountTypeEnum = Meevo.Model.ProductUsageAmountTypeEnum;

    enum QuantityViewType {
        Decimal = 0,
        Units = 1
    }

    interface IDateRange {
        from: Date;
        to: Date;
        presetList: Array<any>;
        predefinedPresetStatus: PresetStatus
    };

    interface ISupplyUsageCombinedItem extends ISupplyUsageLineItem {
        lastTransactionId: Guid | string,
        parsedDateCreated: string,
        undo?: boolean
    }

    interface InventorySearchCountLineItems extends InventoryCountLineItems {
        _selected?: boolean,
        quantity?: number,
        quantityUnits?: number,
        _employee?: Meevo.Model.EmployeeListItem
    }

    interface ISupplyUsagePostModel {
        usageList: Array<ISupplyUsagePostItem>,
        returnUsageList: Array<Guid>
    }

    interface ISupplyUsagePostItem {
        employee_User_TId: Guid | string,
        variantId: Guid | string,
        prodType: ProductInventoryTypeEnum,
        quantity: number,
        quantityUnits: number,
        usageReasonId: Guid | string
    }

    class SupplyUsageItem {
        public dateCreated: string;
        public sku: string;
        public barCode: string;
        public productDisplayName: string;
        public variantDisplayName: string;
        public employeeUserDisplayName: string;
        public quantityDisplay: number;
        public employee_User_TId: string;
        public usageReasonId: Guid | string;
        public usageReasonDisplayName: string;
        public originalEmployee_User_TId: string;
        public originalEmployeeUserDisplayName: string;
        public originalUsageReasonId: Guid | string;
        public originalUsageReasonDisplayName: string;
        public productId: string;
        public variantId: string;
        public prodType: number;
        public quantity: number;
        public quantityUnits?: number;
        public isNew?: boolean = false;
        public timeAdded: number;
        public employeeSupplyUsage_LId: Guid;
        public undo: boolean = false;
        public retail: string;
        public returnUsageId?: Guid;
        public isReturned: boolean = false;
        public wholesale: number;
        public supplyCategoryEnum?: number;
        public supplyCategoryDisplayName?: string;
        public isUpdated: boolean = false;
        public isInEditMode: boolean = false;
        public employee: any = {};
        public usageReason: any = {};
        public entityVersion?: number;
        public wholeProducts: number;
        public partialUnits: number;
        public usageTotal: number;
        public unitOfMeasureQuantity: any;
        public enableProductUsageTracking: boolean;
        public productUsageType: ProductUsageAmountTypeEnum;
        public newQuantityDisplay: number;
        public onHand?: number;
        public decimalPrecision?: number;
        public transactionId?: string;
        public unitsDisplay?: number;
        private _previousValues: { [key: string]: any };
        private watchFields: string[];

        get showUndoButton(): boolean {
            return !this.isNew && !this.showDeleteButton;
        }

        get showDeleteButton(): boolean {
            return !this.isNew && moment(this.dateCreated).toDate() > moment().startOf('day').toDate() && !this.undo;
        }

        get isTransaction(): boolean {
            return Model.Guard.isSomething(this.transactionId);
        }

        get isEditable(): boolean {
            return !this.isReturned && !this.isTransaction;
        }

        get changedFields(): { [key: string]: any } {
            return this.watchFields
                .filter(fieldName => this[fieldName] !== this._previousValues[fieldName])
                .reduce((all, current) => {
                    all[current] = this[current];

                    return all;
                }, {})
        }

        constructor(props: SupplyUsageItem) {
            _.extend(this, props);

            this._previousValues = { ...props };

            this.watchFields = [
                'isReturned',
                'isNew',
                'undo',
            ];
        }

        update() {
            this.watchFields.forEach(field => {
                this._previousValues[field] = this[field];
            });
        }

        cancel() {
            this.watchFields.forEach(field => {
                this[field] = this._previousValues[field];
            });
        }
    }

    class EmployeeSupplyUsageController extends ShortCutsStateManagerController {
        static $inject = ['meevo.AppSettings',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.common.IdentityService',
            'meevo.components.logging.LoggingService',
            'meevo.components.common.SecurityService',
            'meevo.components.tracking.TrackingService',
            "meevo.components.common.InventoryRoundingService",
            '$rootScope',
            '$scope',
            '$state',
            'meevo.ContextParams',
            'meevo.components.short-cuts.ShortCutsService',
            'meevo.components.busy.BusyService',
            '$translate',
            '$timeout',
            '$q',
            '$mdSidenav'];

        protected securityKeys = Meevo.Components.Common.SecurityKeys;
        public TransactionUsageReason: Model.DataDetail = {
            id: 'FE000000-0000-0000-0000-000000000000',
            displayName: "Transactions",
        };

        protected showSearch: boolean;

        protected endpoint: string;
        protected baseEndPoint: string;
        protected items: any;
        protected startDate: any;
        protected endDate: any;
        protected StatusFilters: any;
        protected isReadOnly: boolean;
        protected payrollItem: any;
        protected employeeFilter: any;
        protected employeeCatFilter: any;
        public searching: boolean = false;
        protected hasChanged: boolean = false;
        protected employeePlaceholderLabel: string;
        protected decimalPrecision: number;

        public switchButtons: Meevo.Components.Controls.ISwitchButton[] = [
            { displayName: 'Decimal', key: QuantityViewType.Decimal },
            { displayName: 'Units', key: QuantityViewType.Units },
        ];
        public QuantityViewType = QuantityViewType;

        public dateRange: IDateRange = {
            from: null,
            to: null,
            presetList: [
                { name: 'LABEL_CUSTOM', status: PresetStatus.Custom },
                { name: 'LABEL_TODAY', status: PresetStatus.Today },
                { name: 'LABEL_YESTERDAY', status: PresetStatus.Yesterday },
                { name: 'LABEL_LAST_SEVEN_DAYS', status: PresetStatus.LastSevenDays },
                { name: 'LABEL_THIS_WEEK', status: PresetStatus.ThisWeek },
                { name: 'LABEL_LAST_WEEK', status: PresetStatus.LastWeek },
                { name: 'LABEL_PREVIOUS_TWO_WEEKS', status: PresetStatus.PreviousTwoWeeks },
                { name: 'LABEL_THIS_MONTH', status: PresetStatus.ThisMonth },
                { name: 'LABEL_LAST_MONTH', status: PresetStatus.LastMonth },
                { name: 'LABEL_THIS_QUARTER ', status: PresetStatus.ThisQuarter },
                { name: 'LABEL_LAST_QUARTER', status: PresetStatus.LastQuarter },
                { name: 'LABEL_THIS_YEAR', status: PresetStatus.ThisYear },
                { name: 'LABEL_LAST_TWELVE_MONTHS', status: PresetStatus.LastTwelveMonths }
            ],
            predefinedPresetStatus: PresetStatus.LastSevenDays
        };
        public totalUsageList: Array<SupplyUsageItem>;
        public selectedProduct: VariantUsage;
        // public selectedProductUsage: VariantUsage;
        public selectedManufacturer: Model.Manufacturer;
        public selectedDistributor: Model.Distributor;
        public selectedEmployee: any = null;
        public selectedUsageReason: any = null;
        public employeeId: any = null;
        public defaultSelectedEmployeeId: Guid;
        public newUList = [];
        public newUEmp;
        public newUsageReason: any = null;
        public newUProducts;
        public newProductVariant;
        public includeInactiveToNewProductVariantSearch: boolean = false;
        public inventoryCountProductVariantCriteria = {
            productObjectState: Meevo.Model.ObjectStateEnum.Active,
            variantObjectState: [Meevo.Model.ObjectStateEnum.Active],
            isInventoryTrackable: true,
            manufacturerId: null,
            floorLocationId: null,
            inventoryCountOnly: false,
            isMiscellaneous: null,
            includeNotForSale: true,
            filter: null,
            explicitProductInventoryTypes: [],
            productInventoryTypes: []
        };
        public newUQty;
        public currentProduct;
        public showProductList;
        public employees: any;
        public newQuantityDisplay;
        public newUsageLine;
        public newProductOnHand: Meevo.Model.StockLevel = null;
        public productWholesalePrice;
        public todaysDate: string;
        public employeeTypeAheadCriteria: Object = {
            showEmployeesOnly: true,
            showTerminated: false,
            includeInactive: false,
            includeActive: true
        };
        public retailCheckbox: boolean = true;
        public shopSupplyCheckbox: boolean = true;
        public miscSupplyCheckbox: boolean = true;
        public hideFilters: boolean = false;
        public mdSidenavIsClosed: boolean = false;
        public isPartialAmount?: boolean = null;
        public onHandDecimal: number = null;
        public tenantEnableProductUsageTracking: boolean = false;
        public inventoryNegativeTracking: boolean = false;

        protected shortCutGroup: IShortCutGroup;

        get usageList(): SupplyUsageItem[] {
            return this.totalUsageList.filter(item => item.isNew && !item.isTransaction);
        }

        get returnUsageList(): SupplyUsageItem[] {
            return this.totalUsageList.filter(item => item.undo && !item.isTransaction);
        }

        get updatedList(): SupplyUsageItem[] {
            return this.totalUsageList.filter(item => item.isUpdated && !item.isNew && !item.isTransaction);
        }



        public canSeeWholesaleCost: boolean = false;
        public WholeSaleKey: string = Meevo.Components.Common.SecurityKeys.INVENTORY_EMPLOYEESUPPLYUSAGE_TAB_MAIN_WHOLESALECOST;
        public HouseEmployee: Model.EmployeeListItem = {
            id: Guid.empty.toString(),
            displayName: "HOUSE: House",
            lastName: "House",
            firstName: "House",
            code: "HOUSE",
            isEmployee: false,
            allowSales: true,
            allowTips: true
        };

        public viewQuantity: QuantityViewType = QuantityViewType.Decimal;
 
        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected roundingService: Meevo.Components.Common.IInventoryRoundingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $translate: angular.translate.ITranslateService,
            protected $timeout: angular.ITimeoutService,
            private $q: angular.IQService,
            protected $mdSidenav: ng.material.ISidenavService,
            public productSearchCriteria: string,
            public productRetailPrice: string,
            public customButtonsSet: Array<Meevo.Components.Controls.IMaintenanceFormCustomButton> = [],
            private _productSearchList: Array<InventorySearchCountLineItems> = [],
            private _usageList: Array<ISupplyUsageLineItem> = [],
            private _filteredUsageList: Array<ISupplyUsageCombinedItem> = [],
            private _combinedUsageList: Array<ISupplyUsageCombinedItem> = [],
            public model: ISupplyUsagePostModel,
            public productSelectedList: Array<InventorySearchCountLineItems> = [],
            public productType: ProductInventoryTypeEnum = ProductInventoryTypeEnum.Retail) {
            super($scope, $state, shortCutsService);

            this.noun = Meevo.Model.NounEnum.EmployeeSupplyUsage;

            this.shortCutGroup = new ShortCutGroup([
                { shortCutName: 'DATA_MAINTENANCE_EDIT', callback: () => this.edit() },
                { shortCutName: 'DATA_MAINTENANCE_CANCEL', callback: () => this.cancel() },
                { shortCutName: 'DATA_MAINTENANCE_SAVE', callback: () => this.save() },
            ]);


            this.todaysDate = moment().format();
            this.isReadOnly = true;
            this.endpoint = appSettings.API_ENDPOINTS.employeeSupplyUsage;
            this.baseEndPoint = appSettings.API_ROOT + '/' + this.endpoint;
            this.showSearch = true;
            this.items = new Meevo.Components.BaseClasses.PagedResults(this.dataService, this.endpoint);
            this.defaultSelectedEmployeeId = null; //identityService.current().userAuthId;
            this.employeePlaceholderLabel = "LABEL_SEARCH_FOR_EMPLOYEE";
            this.decimalPrecision = this.appSettings.APP_BUSINFOSETTINGS.generalSettings.inventoryDecimalPrecision || 4;
            this.tenantEnableProductUsageTracking = this.appSettings.APP_BUSINFOSETTINGS.generalSettings.productUsageTracking || false;
            this.inventoryNegativeTracking = this.appSettings.APP_BUSINFOSETTINGS.generalSettings.trackNegativeInventory || false;

            this.securityService.checkModuleAccess(Meevo.Components.Common.SecurityKeys.DATA_STUDENTTEACHERMODULE
                + Meevo.Components.Common.SecurityParts.KEY_PART_READ).
                then((securityAccess: Meevo.Model.SecurityAccessEnum) => {
                    if (securityAccess == Meevo.Model.SecurityAccessEnum.Grant) {
                        this.employeePlaceholderLabel = "LABEL_SEARCH_FOR_EMPLOYEE_STUDENT_OR_TEACHER";
                    }
                });

            this.$scope.$watch(() => this.selectedEmployee, newValue => {
                this.employeeId = !newValue ? null : newValue.id;
            });

            this.securityService.checkSecurityKey(this.WholeSaleKey + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
                .then((sec: Model.SecurityAccessEnum) => {
                    this.canSeeWholesaleCost = (sec == Model.SecurityAccessEnum.Grant);
                });
        }

        initializeSearch = () => {
            let request = {
                pageNumber: 0,
                itemsPerPage: 25,
                criteria: {
                    startDate: this.startDate,
                    endDate: this.endDate
                }
            };
            this.items.initSearch(request);
        };

        /**
         * Changed product type
         * @param {boolean} reset - trigger product search model reset if needed
         * */

        public showFilters = () => {
            this.hideFilters = true;
        }

        public changedProductSearch(reset: boolean = false): void {
            if (reset) {
                this.productSearchCriteria = '';
                this.showProductList = false;
            }

            if (this.productSearchCriteria) {
                let criteria = {
                    PageNumber: 0,
                    ItemsPerPage: 10000,
                    criteria: {
                        productObjectState: Meevo.Model.ObjectStateEnum.Active,
                        variantObjectState: [Meevo.Model.ObjectStateEnum.Active, Meevo.Model.ObjectStateEnum.Inactive],
                        isInventoryTrackable: true,
                        manufacturerId: null,
                        floorLocationId: null,
                        inventoryCountOnly: false,
                        filter: this.productSearchCriteria,
                        isMiscellaneous: null,
                        includeNotForSale: true,
                        productInventoryTypes: this.getProductTypes(),
                        explicitProductInventoryTypes: this.getProductTypes()
                    }
                };

                this.searching = true;
                //this.switchContextState(true);

                this.busyService.start();
                this.dataService.getListPaged('InventoryCount/ProductVariant', criteria)
                    .then((data: Array<InventoryCountLineItems>) => {
                        this.productSearchList = data;
                        this.showProductList = true;
                    })
                    .finally(() => {
                        this.busyService.stop();
                    });
            }
        }

        public addProduct(item) {
            if (item) {
                this.productSearchCriteria = item.productName || item.displayName;
                this.productRetailPrice = item.retail;
                this.productWholesalePrice = item.wholesale || item.wholeSale;
                this.newUsageLine = item;
                this.newUsageLine.retailOrShopSupplyItem = item.productInventoryType === ProductInventoryTypeEnum.RetailOrShopSupply;
                this.showProductList = false;
            }
            else {
                this.productSearchCriteria = null;
                this.productRetailPrice = null;
                this.productWholesalePrice = null;
                this.newUsageLine = null;
                this.showProductList = false;
            }
        }

        public setProductVariantCriteria() {
            this.inventoryCountProductVariantCriteria.filter = this.productSearchCriteria;
            this.inventoryCountProductVariantCriteria.productInventoryTypes = [ProductInventoryTypeEnum.Retail, ProductInventoryTypeEnum.ShopSupply, ProductInventoryTypeEnum.RetailOrShopSupply, ProductInventoryTypeEnum.Other];
            this.inventoryCountProductVariantCriteria.explicitProductInventoryTypes = [ProductInventoryTypeEnum.Retail, ProductInventoryTypeEnum.ShopSupply, ProductInventoryTypeEnum.RetailOrShopSupply, ProductInventoryTypeEnum.Other];
        }

        public updateProductVariantCriteria() {
            this.inventoryCountProductVariantCriteria.filter = this.productSearchCriteria;
            this.inventoryCountProductVariantCriteria.productInventoryTypes = [ProductInventoryTypeEnum.Retail, ProductInventoryTypeEnum.ShopSupply, ProductInventoryTypeEnum.RetailOrShopSupply, ProductInventoryTypeEnum.Other];
            this.inventoryCountProductVariantCriteria.explicitProductInventoryTypes = [ProductInventoryTypeEnum.Retail, ProductInventoryTypeEnum.ShopSupply, ProductInventoryTypeEnum.RetailOrShopSupply, ProductInventoryTypeEnum.Other];
            if (this.includeInactiveToNewProductVariantSearch) {
                this.inventoryCountProductVariantCriteria.variantObjectState = [Meevo.Model.ObjectStateEnum.Active, Meevo.Model.ObjectStateEnum.Inactive];
            }
            else {
                this.inventoryCountProductVariantCriteria.variantObjectState = [Meevo.Model.ObjectStateEnum.Active];
            }
        }

        public productVariantSelected() {
            this.addProduct(this.newProductVariant);
            this.setFocusOnButton(0);
            this.updateOnHand();
        }

        public updateOnHand() {
            if (this.newProductVariant && (this.newProductVariant.id != null || this.newProductVariant.id != Guid.empty)) {
                var productInventoryType = (this.newProductVariant.productInventoryType == Model.ProductInventoryTypeEnum.RetailOrShopSupply)
                                            ? (!this.newUsageLine || this.newUsageLine.productInventoryType == Model.ProductInventoryTypeEnum.RetailOrShopSupply
                                                ? Model.ProductInventoryTypeEnum.ShopSupply
                                                : this.newUsageLine.productInventoryType)
                                            : this.newProductVariant.productInventoryType;

                var request = {
                    criteria: {
                        variantIds: [this.newProductVariant.id],
                        isMiscellaneous: (this.newProductVariant.productInventoryType == ProductInventoryTypeEnum.Other),
                        productInventoryTypes: [productInventoryType],
                        productInventoryType: productInventoryType
                    }
                };
                return this.dataService.customMethodData("api/Inventory/StockLevel/List", "POST", request)
                    .then((response) => {
                        if (response && response.data && response.data.length > 0) {
                            this.newProductOnHand = response.data[0];
                            this.isPartialAmount = (this.newProductOnHand && this.isProductUsageEnabled(this.newProductOnHand));
                            let onHandHasPartialAmount = (this.newProductOnHand && !Number.isInteger(this.newProductOnHand.onHand));
                            this.onHandDecimal = (onHandHasPartialAmount || this.isPartialAmount) ? this.decimalPrecision : null;
                            this.newQuantityDisplay = this.isPartialAmount ? 0 : 1;
                        }
                    });
            }

            return this.$q.resolve()
                .then(() => {
                    this.newProductOnHand = null;
                });
        }

        public onHandBelowOrderPoint(): boolean {
            if (!this.newProductOnHand) {
                return false;
            }

            let onHandValue: number = (!this.inventoryNegativeTracking
                && this.newProductOnHand.onHand != null
                && !isNaN(this.newProductOnHand.onHand)
                && this.newProductOnHand.onHand < 0) ? 0 : this.newProductOnHand.onHand;

            return (this.newProductOnHand.modelQuantity > this.newProductOnHand.orderPoint && onHandValue <= this.newProductOnHand.orderPoint)
                || (this.newProductOnHand.modelQuantity == this.newProductOnHand.orderPoint && onHandValue < this.newProductOnHand.orderPoint)
                || (this.newProductOnHand.modelQuantity < this.newProductOnHand.orderPoint && onHandValue < this.newProductOnHand.modelQuantity);
        }

        public employeeSearchCriteria = {
            showEmployeesOnly: true,
            showTerminated: false,
            productInventoryTypes: this.getInventoryInventoryType(),
            explicitProductInventoryTypes: this.getInventoryInventoryType(),
            isInventoryTrackable: true
        };

        getInventoryInventoryType(): any {
            let productInventoryTypes = [];
            if (this.shopSupplyCheckbox)
                productInventoryTypes.push(ProductInventoryTypeEnum.ShopSupply);
            if (this.retailCheckbox)
                productInventoryTypes.push(ProductInventoryTypeEnum.Retail);
            if (this.miscSupplyCheckbox)
                productInventoryTypes.push(ProductInventoryTypeEnum.Other);
            return productInventoryTypes;
        }

        updateSearchCriteria() {
            this.employeeSearchCriteria.productInventoryTypes = this.getInventoryInventoryType();
            this.employeeSearchCriteria.explicitProductInventoryTypes = this.getInventoryInventoryType();
        }

        public resetProductSearch() {
            this.newUsageLine = null;
            this.productSearchCriteria = null;
            this.productWholesalePrice = null;
            this.productRetailPrice = null;
            this.newProductVariant = null;
            this.showProductList = false;
            this.hasChanged = false;
            this.isPartialAmount = null;
        }

        public edit() {
            if (!this.totalUsageList) {
                this.totalUsageList = []; // set to empty list
            }
            this.isReadOnly = false;
            this.todaysDate = moment().format();
            this.$mdSidenav('empSupplySidenav').close();
            this.mdSidenavIsClosed = true;
            this.setFocusOnProduct(500);
            this.usageTrackingLog(Meevo.Model.VerbEnum.EditButtonClicked, null);
        }

        public cancel() {
            if (this.hasChanged) {
                this.modalService.alert("MESSAGE_ARE_YOU_SURE_YOU_WAN_TO_CANCEL_CLICK_YES", Meevo.Components.Modal.ModalTranslationModes.Translate, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                    .then((response: boolean) => {
                        if (response) {
                            this.finishCancel();
                        }
                    });
            }
            else {
                this.finishCancel();
            }
        }

        public finishCancel() {
            this.usageTrackingLog(Meevo.Model.VerbEnum.CancelButtonClicked, null);
            this.totalUsageList = this.totalUsageList.filter(item => !item.isNew);
            this.totalUsageList.forEach(item => item.cancel());
            this.isReadOnly = true;
            this.resetProductSearch();
        }

        public calculateWholeSale(item: SupplyUsageItem) {
            let quantity = item.quantityDisplay || this.getCalculatedQuantity(item);
            return this.calculateWholeSaleFromDetails(item.wholesale, quantity, item.enableProductUsageTracking, item.productUsageType);
        }

        public calculateWholeSaleFromDetails(price, quantity, enableProductUsageTracking, productUsageType) {
            return ((this.tenantEnableProductUsageTracking && enableProductUsageTracking && productUsageType == ProductUsageAmountTypeEnum.PartialAmount)
                ? this.roundingService.multiply(price, quantity, this.decimalPrecision)
                : (price * quantity)) || 0; // NaN check
        }

        private isSaving: boolean = false;
        /**
         * Saves the item currently being edited/added.
         */

        save(): angular.IPromise<any> {
            if (this.usageList.length === 0 && this.returnUsageList.length === 0 && this.updatedList.length === 0) {
                // nothing to save
                return this.$q.resolve(() => this.isReadOnly = true);
            }

            if (this.isSaving) {
                // stop saving twice
                return;
            }
            this.isSaving = true;
            this.busyService.start();

            this.usageTrackingLog(Meevo.Model.VerbEnum.SaveButtonClicked, null);

            let saveData = {
                usageList: this.usageList,
                returnUsageList: this.returnUsageList,
                updatedList: this.updatedList
            };
            return this.dataService.customMethodData(this.baseEndPoint, 'POST', saveData)
                .then((response: any) => {
                    this.isReadOnly = true;
                    this.totalUsageList = _.filter(this.totalUsageList, (item: SupplyUsageItem) => { return !item.isNew; });
                    var addlNewItems = (response.data || []);
                    addlNewItems.forEach((addlItem: any, ndx, arr) => {
                        var ni = new SupplyUsageItem(addlItem);
                        ni.quantityDisplay = this.getCalculatedQuantity(ni);
                        ni.decimalPrecision = (!Number.isInteger(ni.quantityDisplay) || this.isProductUsageEnabled(ni)) ? this.decimalPrecision : null;
                        ni.prodType = addlItem.productInventoryTypeEnum || addlItem.productInventoryType;
                        if (!ni.isReturned) {
                            if (ni.isUpdated) {
                                var updatedItem = _.findWhere(this.totalUsageList, { employeeSupplyUsage_LId: ni.employeeSupplyUsage_LId });
                                if (updatedItem) {
                                    updatedItem.entityVersion = ni.entityVersion;
                                }
                            }
                            else {
                                ni.employee = ni.employee_User_TId ? { id: ni.employee_User_TId, displayName: ni.employeeUserDisplayName } : angular.copy(this.HouseEmployee);
                                ni.usageReason = ni.usageReasonId ? { id: ni.usageReasonId, displayName: ni.usageReasonDisplayName } : null;
                                this.totalUsageList.unshift(ni);
                            }
                        }
                    });
                    this.totalUsageList = _.filter(this.totalUsageList, (item: SupplyUsageItem) => { return !item.undo || _.findWhere(addlNewItems, { employeeSupplyUsage_LId: item.employeeSupplyUsage_LId }) != null });
                    this.totalUsageList.forEach(item => {
                        if (item.undo) {
                            item.isReturned = true;
                            item.undo = null;
                        }
                        item.isUpdated = false;
                    });
                    this.loggingService.trace(`Updates saved.`);
                    this.productWholesalePrice = 0;
                    this.hasChanged = false;
                    //this.selectSection(this.selectedSection); // trigger loading of usage list
                })
                .finally(() => {
                    this.isSaving = false;
                    this.busyService.stop();
                });
        }

        getItemTotalPrice(): number {
            var total = 0;
            if (this.totalUsageList != null && this.totalUsageList.length > 0) {
                for (var i = 0; i < this.totalUsageList.length; i++) {
                    var item = this.totalUsageList[i];
                    if (!item.isReturned) {
                        total = this.roundingService.add(total, this.roundingService.multiply(item.wholesale, item.quantityDisplay, this.decimalPrecision), this.decimalPrecision);
                    }
                }
            }
            return total || 0; // NaN check
        }

        public preSave(): ISupplyUsagePostModel {
            let uList: Array<ISupplyUsagePostItem> = [];
            let rUList: Array<any> = [];
            let fList: Array<any> = [];

            this.productSelectedList.forEach((item) => {
                if (item._selected) {
                    uList.push({
                        employee_User_TId: item._employee && item._employee.id,
                        variantId: item.variantId,
                        prodType: item.productInventoryType,
                        quantity: item.quantity,
                        quantityUnits: item.quantityUnits,
                        usageReasonId: null
                    })
                } else {
                    fList.push(item)
                }
            });

            this.filteredUsageList.forEach((item) => {

                if (item.undo) {
                    rUList.push(item.lastTransactionId);
                }
            });

            this.productSelectedList = fList;

            this.model = {
                usageList: uList,
                returnUsageList: rUList
            };

            return this.model;
        }


        public changedProductType(): void {
            let list: Array<ISupplyUsageCombinedItem> = [];

            this.combinedUsageList.forEach((item) => {
                if (this.productType === item.productInventoryTypeEnum || ProductInventoryTypeEnum.RetailOrShopSupply === item.productInventoryTypeEnum) {
                    list.push(item);
                }
            });

            this.filteredUsageList = list;
        }

        /**
         * Callback for meevo-date-range-with-presets directive
         * @param {ChangedDateEnum} changedDate
         */

        public dateChanged(changedDate: ChangedDateEnum): ng.IPromise<any> {
            if (this.isDateValide()) {
                return this.filterData();
            }
        }

        /**
         * Do filtering
         */
        private filterData(): ng.IPromise<any> {
            let data = {
                criteria: {
                    startDateTime: this.dateRange.from,
                    endDateTime: this.dateRange.to,
                    employee_User_TId: this.employeeId ? this.employeeId : undefined,
                    variant_TId: this.selectedProduct ? this.selectedProduct["variantId"] : undefined,
                    productInventoryTypes: this.getProductTypes(true),
                    explicitProductInventoryTypes: this.getProductTypes(true),
                    manufacturerId: this.selectedManufacturer ? this.selectedManufacturer.id : null,
                    distributorId: this.selectedDistributor ? this.selectedDistributor.id : null,
                    usageReasonId: this.selectedUsageReason ? this.selectedUsageReason.id : null,
                    unitOfMeasureQuantity: this.selectedProduct ? this.selectedProduct['unitOfMeasureQuantity'] : null
                },
                filtered: true,
                itemsPerPage: 10000   
            };

            this.busyService.start();
            return this.dataService.customMethodData('/api/Inventory/SupplyUsage/List', 'POST', data)
                .then((response) => {
                    for (var i = 0; i < response.data.length; i++) {
                        var entry: SupplyUsageItem = response.data[i];
                        entry.quantityDisplay = this.getCalculatedQuantity(entry);
                        entry.decimalPrecision = (!Number.isInteger(entry.quantityDisplay) || this.isProductUsageEnabled(entry)) ? this.decimalPrecision : null;
                        entry.unitOfMeasureQuantity = entry.unitOfMeasureQuantity;
                        entry.prodType = entry["productInventoryTypeEnum"] || entry["productInventoryType"];
                        if (!entry.employee_User_TId) {
                            entry.employee = angular.copy(this.HouseEmployee);
                        }
                        else {
                            entry.employee = { id: entry.employee_User_TId ? entry.employee_User_TId : this.HouseEmployee.id, displayName: entry.employee_User_TId ? entry.employeeUserDisplayName : this.HouseEmployee.displayName };
                        }
                        entry.usageReason = { id: entry.usageReasonId, displayName: entry.usageReasonDisplayName };
                    }
                    this.totalUsageList = (response.data || []).map(item => new SupplyUsageItem(item));
                    if (this.totalUsageList.length === 0) {
                        this.modalService.alert("MESSAGE_NO_RESULTS_FOUND", Meevo.Components.Modal.ModalTranslationModes.Translate, false, { okButtonHotKey: 'MODAL_OK_BUTTON', okButtonContentKey: 'LABEL_OK' })
                            .then((response: boolean) => {});
                    }
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        public getProductTypes(search: boolean = false): any {
            let productInventoryType = [];

            switch (true) {
                case (this.shopSupplyCheckbox && this.retailCheckbox && search):
                    productInventoryType = [ProductInventoryTypeEnum.Retail, ProductInventoryTypeEnum.ShopSupply, ProductInventoryTypeEnum.RetailOrShopSupply];
                    break;
                case (this.shopSupplyCheckbox && this.retailCheckbox && !search):
                    productInventoryType = [ProductInventoryTypeEnum.Retail, ProductInventoryTypeEnum.ShopSupply];
                    break;
                case (this.shopSupplyCheckbox && !this.retailCheckbox && search):
                    productInventoryType = [ProductInventoryTypeEnum.ShopSupply, ProductInventoryTypeEnum.RetailOrShopSupply];
                    break;
                case (!this.shopSupplyCheckbox && this.retailCheckbox && search):
                    productInventoryType = [ProductInventoryTypeEnum.Retail, ProductInventoryTypeEnum.RetailOrShopSupply];
                    break;
                case (this.shopSupplyCheckbox && !this.retailCheckbox && !search):
                    productInventoryType = [ProductInventoryTypeEnum.ShopSupply];
                    break;
                case (!this.shopSupplyCheckbox && this.retailCheckbox && !search):
                    productInventoryType = [ProductInventoryTypeEnum.Retail];
                    break;
            }
            if (this.miscSupplyCheckbox)
                productInventoryType.push(ProductInventoryTypeEnum.Other)

            return productInventoryType;
        }

        public addSupplyUsageLine() {
            if (this.totalUsageList == undefined) {
                this.totalUsageList = new Array<SupplyUsageItem>();
            }
            this.totalUsageList.unshift(
                new SupplyUsageItem(<SupplyUsageItem>{
                    dateCreated: this.todaysDate,
                    sku: this.newUsageLine.sku,
                    barCode: this.newUsageLine.barCode,
                    productDisplayName: this.newUsageLine.productName || this.newUsageLine.displayName,
                    variantDisplayName: (this.newUsageLine.productName != null) ? this.newUsageLine.displayName : this.newUsageLine.variantDisplayName,
                    employeeUserDisplayName: this.newUEmp ? this.newUEmp.displayName : null,
                    quantityDisplay: this.newQuantityDisplay,
                    employee_User_TId: this.newUEmp ? this.newUEmp.id : null,
                    usageReasonId: this.newUsageReason ? this.newUsageReason.id : null,
                    usageReasonDisplayName: this.newUsageReason ? this.newUsageReason.displayName : null,
                    productId: this.newUsageLine.productId,
                    variantId: this.newUsageLine.id,
                    prodType: this.newUsageLine.productInventoryType,
                    quantity: this.isPartialAmount ? this.newUsageLine.quantity : this.newQuantityDisplay,
                    quantityUnits: this.newUsageLine.quantityUnits,
                    decimalPrecision: this.isPartialAmount ? this.decimalPrecision : null,
                    isNew: true,
                    timeAdded: new Date().getTime(),
                    retail: this.newUsageLine.retail,
                    wholesale: this.newUsageLine.wholesale || this.newUsageLine.wholeSale,
                    employee: this.newUEmp ? { id: this.newUEmp.id, displayName: this.newUEmp.displayName } : angular.copy(this.HouseEmployee),
                    usageReason: this.newUsageReason ? { id: this.newUsageReason.id, displayName: this.newUsageReason.displayName } : null,
                    unitOfMeasureQuantity: this.newUsageLine.unitOfMeasureQuantity
                })
            );
            //this.save();
            this.newProductOnHand = null;
            this.newQuantityDisplay = 0;
            this.resetProductSearch();
            this.setFocusOnProduct();
            this.hasChanged = true;
        }

        public closeContext(): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
        }
        showSidebar = () => {
            this.$mdSidenav('empSupplySidenav').open();
            this.mdSidenavIsClosed = false;
        }
        hideSidebar = () => {
            this.$mdSidenav('empSupplySidenav').close();
            this.mdSidenavIsClosed = true;
        }

        /**
         * Show modal window with product and employee loockups inside
         */


        /**
         * Check if date is out of range
         * @returns {boolean}
         */

        private isDateOutOfRange(): boolean {
            let from = moment(this.dateRange.from),
                to = moment(this.dateRange.to);

            return to.diff(from, 'days') > 90;
        }

        /**
         * Check if end date goes after start date
         * @returns {boolean}
         */

        private isDateValide(): boolean {
            let from = moment(this.dateRange.from),
                to = moment(this.dateRange.to);

            return to.isAfter(from);
        }

        get combinedUsageList(): Array<ISupplyUsageCombinedItem> {
            return this._combinedUsageList;
        }

        get filteredUsageList(): Array<ISupplyUsageCombinedItem> {
            return this._filteredUsageList;
        }

        set filteredUsageList(list: Array<ISupplyUsageCombinedItem>) {
            this._filteredUsageList = list;
        }

        get productSearchList(): Array<InventorySearchCountLineItems> {
            return this._productSearchList;
        }

        get productInventoryTypeEnum(): any {
            return ProductInventoryTypeEnum
        }

        set productSearchList(list: Array<InventorySearchCountLineItems>) {
            this._productSearchList = list;
        }

        get availableToAddItem(): boolean {
            return this.newQuantityDisplay > 0 && this.newProductVariant != null;
        }

        public startEmployeeUsageGroupedByCategory(): ng.IPromise<any> {
            return this.showEmployeeUsageGroupedByCategory().then(groupData => {
                return this.modalService.showCustom({
                    templateUrl: "app/plugins/employeeSupplyUsage/sectionViews/groupedSupplyUsage.html",
                    controller: "meevo.plugins.employeeSupplyUsage.GroupedEmployeeSupplyUsageController",
                    controllerAs: "vm",
                    bindToController: true,
                    multiple: true,
                    skipHide: true,
                    locals: {
                        groupedData: groupData
                    }
                });
            });
        }

        public showEmployeeUsageGroupedByCategory(): ng.IPromise<any> {
            var request: any = {
                criteria: {
                    startDateTime: this.dateRange.from,
                    endDateTime: this.dateRange.to,
                    employee_User_TId: this.employeeId ? this.employeeId : undefined,
                    variant_TId: this.selectedProduct ? this.selectedProduct["variantId"] : undefined,
                    productInventoryTypes: this.getProductTypes(true),
                    explicitProductInventoryTypes: this.getProductTypes(true),
                    manufacturerId: this.selectedManufacturer ? this.selectedManufacturer.id : null,
                    distributorId: this.selectedDistributor ? this.selectedDistributor.id : null,
                    usageReasonId: this.selectedUsageReason ? this.selectedUsageReason.id : null,
                    sortBy: "ProductCategory,ProductSubCategory,Sku",
                    sortOrder: "ASC, ASC, ASC"
                },
                filtered: true,
                isCount: true
            }; 
            this.busyService.start();

            request.isCount = false;
            request.itemsPerPage = 1000000;
            return this.dataService.getListPaged(this.appSettings.API_ENDPOINTS.employeeSupplyUsage, request)
                .then((data: any[]) => {

                    if (data.length == 0) {
                        this.busyService.stop();
                        return {
                            groups: [],
                            totalWholesale: 0,
                            totalQuantity: 0,
                            decimalPrecision: null,
                            hasPartialUsageInAGroup: false,
                        };
                    }

                    var hasPartialUsageInAGroup: boolean = false;
                    var supplyUsageGroups: any[] = [];
                    var groups: _.Dictionary<any> = _.groupBy(data, (item) => (item.supplyCategoryEnum != null ? item.supplyCategoryEnum : item.productCategoryId));
                    for (var key in groups) {
                        var subTotal = 0;
                        var subTotalQty = 0;
                        _.each(groups[key], (pc: any) => {
                            if (!pc.isReturned) {
                                let quantity: number = this.getCalculatedQuantity(pc);
                                subTotal = this.roundingService.add(subTotal, this.roundingService.multiply(quantity, pc.wholesale, this.decimalPrecision), this.decimalPrecision);
                                subTotalQty = this.roundingService.add(subTotalQty, quantity, this.decimalPrecision);
                            }
                        });
                        var usageGroup = {
                            key: key,
                            displayName: (groups[key][0].supplyCategoryEnum != null) ? groups[key][0].supplyCategoryDisplayName : groups[key][0].productCategoryName,
                            subTotalWholesale: subTotal,
                            subTotalQuantity: subTotalQty,
                            isGroup: true,
                            decimalPrecision: null,
                            hasPartialUsage: false,
                            items: []
                        }
                        var isGroupEmpty: boolean = true;
                        var variantGroups = _.groupBy(groups[key], "variant_TId");
                        for (var vkey in variantGroups) {
                            var countTotal = 0;
                            var wholesaleTotal = 0;
                            var isVariantGroupEmpty: boolean = true;
                            _.each(variantGroups[vkey], (vi: any) => {
                                if (!vi.isReturned) {
                                    let quantity: number = this.getCalculatedQuantity(vi);
                                    countTotal = this.roundingService.add(countTotal, quantity, this.decimalPrecision);
                                    wholesaleTotal = this.roundingService.add(wholesaleTotal, this.roundingService.multiply(quantity, vi.wholesale, this.decimalPrecision), this.decimalPrecision);
                                    isGroupEmpty = false;
                                    isVariantGroupEmpty = false;
                                    usageGroup.hasPartialUsage = usageGroup.hasPartialUsage || this.isProductUsageEnabled(vi);
                                    usageGroup.decimalPrecision = (usageGroup.hasPartialUsage) ? this.decimalPrecision : null;
                                }
                            });
                            if (!isVariantGroupEmpty) {
                                var variantItem: any = angular.copy(variantGroups[vkey][0]);
                                variantItem.quantity = countTotal;
                                variantItem.totalWholesale = wholesaleTotal;
                                usageGroup.items.push(variantItem);
                            }
                        }
                        if (!isGroupEmpty) {
                            supplyUsageGroups.push(usageGroup);
                        }
                    }
                    var total = 0;
                    var totalQty = 0;
                    _.each(supplyUsageGroups, (sug: any) => {
                        total = this.roundingService.add(total, sug.subTotalWholesale, this.decimalPrecision);
                        totalQty = this.roundingService.add(totalQty, sug.subTotalQuantity, this.decimalPrecision);
                        hasPartialUsageInAGroup = hasPartialUsageInAGroup || sug.hasPartialUsage;
                    });
                    return {
                        groups: supplyUsageGroups,
                        totalWholesale: total,
                        totalQuantity: totalQty,
                        decimalPrecision: (hasPartialUsageInAGroup) ? this.decimalPrecision : null,
                        hasPartialUsageInAGroup: hasPartialUsageInAGroup,
                    };
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        productInformation(item: any, event) {
            event.stopPropagation();
            let modalOptions: Meevo.Plugins.Product.ProductInfoModalOptions = {
                productId: item.productId,
                variantIdInitiator: item.variant_TId,
                productInventoryTypeEnum: item.productInventoryTypeEnum,
                parentType: Meevo.Plugins.Product.ProductInfoModalParent.EmployeeSupplyUsage
            }

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/product/modals/productInformation.template.html",
                controller: "meevo.plugins.product.ProductInformationController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    options: modalOptions
                }
            }
            this.modalService.showCustom(options);
        }

        setPartialUsage(event, entry: SupplyUsageItem) {
            // console.dir(entry)
            event.stopPropagation();

            entry.onHand = this.newProductOnHand.onHand;
            let modalOptions: Meevo.Components.Controls.PartialUsageModalOptions = {
                productId: entry.productId,
                variantIdInitiator: entry.variantId,
                parentType: Meevo.Plugins.Product.ProductInfoModalParent.EmployeeSupplyUsage,
                entry: entry,
                quantityWholeList: [{ quantity: entry.quantity }],
                quantityUnitsList: [{ quantity: entry.quantityUnits }],
                totalCompositeValue: 0,
            }

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/components/controls/productPartialUsage/partialUsage.template.html",
                controller: "meevo.components.controls.productPartialUsage.PartialUsageController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    options: modalOptions
                }
            }
            this.modalService.showCustom(options)
                .then((applied) => {
                    if (applied) {
                        this.newQuantityDisplay = modalOptions.totalCompositeValue;
                        entry.quantity = modalOptions.quantityWholeList[0].quantity;
                        entry.quantityUnits = modalOptions.quantityUnitsList[0].quantity;
                    }
                });
        }

        /**
         * Removing selected (not saved) supply usage item
         * */
        public removeNewSupplyUsageItem(entry: SupplyUsageItem): void {
            this.totalUsageList = this.totalUsageList
                .filter(item => entry.isNew
                    ? item.timeAdded !== entry.timeAdded
                    : item.employeeSupplyUsage_LId !== entry.employeeSupplyUsage_LId
                );
            this.hasChanged = true;
        }

        /**
         * Marking supply usage item to undo/delete
         * */
        public undoSelectedProduct(transactionId: Guid, actionType: 'undo' | 'delete'): void {
            let question = `MESSAGE_${actionType.toUpperCase()}_USAGE_RECORD_CONFIRMATION`;

            this.modalService.warning(question, Meevo.Components.Modal.ModalTranslationModes.Translate, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                .then(() => {
                    let item = this.totalUsageList.filter(item => item.employeeSupplyUsage_LId === transactionId)[0];

                    item.undo = !item.undo;

                    this.hasChanged = true;
                });
        }

        public editSelectedProduct(entry: SupplyUsageItem) {
            if (!entry.isInEditMode) {
                entry.isInEditMode = true;
                entry.originalEmployee_User_TId = entry.employee_User_TId;
                entry.originalUsageReasonId = entry.originalUsageReasonId;
                entry.employee = { id: entry.employee_User_TId ? entry.employee_User_TId : this.HouseEmployee.id, displayName: entry.employee_User_TId ? entry.employeeUserDisplayName : this.HouseEmployee.displayName };
                entry.usageReason = { id: entry.usageReasonId, displayName: entry.usageReasonDisplayName };
            }
        }

        setFocusOnProduct(t: number = 500) {
           this.$timeout(t).then(() => {
                var obj = $("#empSupplyProductSearchCriteria");
                if (obj && obj.length > 0) {
                    var input = obj.find("input.meevo-typeahead-input");
                    if (input && input.length > 0) {
                        input.focus();
                    }
                }
            });
        }

        setFocusOnButton(t: number = 100) {
            this.$timeout(t).then(() => {
                var obj = $("#empSupplyProductAddBtn");
                if (obj && obj.length > 0) {
                    obj.focus();
                }
            });
        }

        usageTrackingLog(verbEnum, payload): void {
            if (this.trackingService) {
                var trackingItem = new Meevo.Model.TrackingItem(Meevo.Model.NounEnum.EmployeeSupplyUsagePage, verbEnum, payload, null);
                this.trackingService.saveTrackingInfo(trackingItem);
            }
        }

        isHouseEmployeeMatched(filter: string, employeeEntityType?: Model.EmployeeEntityTypeEnum): boolean {
            var isMatched = (filter.length == 0);
            if (!isMatched) {
                var pattern = filter.replace("_", ".").replace("%", "");
                var re = new RegExp(pattern, "i");
                isMatched = (!employeeEntityType || employeeEntityType == Model.EmployeeEntityTypeEnum.Employee)
                    ? (re.test(this.HouseEmployee.displayName) || re.test(this.HouseEmployee.code))
                    : false;
            }
            return isMatched;
        }

        employeeTypeAheadPreProcessData(responseData, requestData): any[] {
            if (requestData.pageNumber == 0) {
                if (this.isHouseEmployeeMatched(requestData.criteria.filter)) {
                    responseData.splice(0, 0, this.HouseEmployee);
                }
                return responseData;
            }
        }

        empChanged(entry: SupplyUsageItem) {
            if (!entry) {
                return; // nothing to do if no 'entry'
            }

            if (!entry.isUpdated) {
                entry.originalEmployee_User_TId = entry.employee_User_TId;
                entry.originalEmployeeUserDisplayName = entry.employeeUserDisplayName;
                entry.originalUsageReasonId = entry.usageReasonId;
                entry.originalUsageReasonDisplayName = entry.usageReasonDisplayName;
            }
            // always treat empty as HOUSE
            if (!entry.employee) {
                entry.employee = angular.copy(this.HouseEmployee);
            }
            if (entry.isUpdated
                || (entry.employee && entry.employee.id !== entry.originalEmployee_User_TId)) {
                entry.isUpdated = true;
            }
            entry.employee_User_TId = entry.employee.id;
            entry.employeeUserDisplayName = entry.employee.displayName;
        }

        reasonChanged(entry: SupplyUsageItem) {
            if (!entry) {
                return; // nothing to do if no 'entry'
            }

            if (!entry.isUpdated) {
                entry.originalEmployee_User_TId = entry.employee_User_TId;
                entry.originalEmployeeUserDisplayName = entry.employeeUserDisplayName;
                entry.originalUsageReasonId = entry.usageReasonId;
                entry.originalUsageReasonDisplayName = entry.usageReasonDisplayName;
            }
            if (entry.isUpdated
                || (entry.usageReason && entry.usageReason.id !== entry.originalUsageReasonId)
                || (!entry.usageReason && (entry.originalUsageReasonId != null || entry.originalUsageReasonId != Guid.empty.toString()))) {
                entry.isUpdated = true;
            }
            if (entry.usageReason) {
                entry.usageReasonId = entry.usageReason.id;
                entry.usageReasonDisplayName = entry.usageReason.displayName;
            }
            else {
                entry.usageReasonId = null;
                entry.usageReasonDisplayName = "";
            }
        }

        showScrollbarSpacer(elemName) {
            var dd = $(elemName);
            return (dd.length > 0 && dd[0].scrollHeight > dd[0].clientHeight);
        }

        getMdItemSize(): number {
            return (this.$scope.isMobileDevice || (this.$scope.isIpad && !this.$scope.isLargeTablet)) ? 250 : 41;
        }

        getCalculatedQuantity(item: SupplyUsageItem): number {
            let partial: number = item.quantityUnits ? this.roundingService.divideNormalizedNumbers(item.quantityUnits, item.unitOfMeasureQuantity, this.decimalPrecision) : 0;
            return this.roundingService.addNormalizedNumbers(item.quantity, partial, this.decimalPrecision);
        }

        getUnitsDisplay(item: SupplyUsageItem, amount?: number): number {
            console.log(item);
            if (amount || amount === 0) {
                return Math.round(this.roundingService.multiply(amount, item.unitOfMeasureQuantity));
            } else {
                let wholeUnits: number = this.roundingService.multiply(item.quantity || 0, item.unitOfMeasureQuantity);
                return this.roundingService.add(wholeUnits, item.quantityUnits || 0);
            }
        }

        openTransactionEditor(transactionNumber: string): void {
            if (!transactionNumber) return;

            // Build params for loading transaction in editor
            let stateParams = {
                transactionId: transactionNumber,
                includeActive: true,
                includeCompleted: true,
                includeOnHold: false,
                includeRefunded: true,
                includeVoided: true
            };

            this.$rootScope.$broadcast("gotoState", {
                stateName: this.appSettings.ROUTE_NAMES.transactionEditor,
                stateParams: stateParams,
                securityKey: this.securityKeys.REGISTER_TRANSACTIONEDITOR + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
            });
        }

        isTransactionUsageReasonMatched(filter: string): boolean {
            var isMatched = (filter.length == 0);
            if (!isMatched) {
                var pattern = filter.replace("_", ".").replace("%", "");
                var re = new RegExp(pattern, "i");
                isMatched = re.test(this.TransactionUsageReason.displayName);
            }
            return isMatched;
        }

        usageReasonPreProcessData(responseData, requestData): any[] {
            if (requestData.pageNumber == 0) {
                if (this.isTransactionUsageReasonMatched(requestData.criteria.filter)) {
                    responseData.splice(0, 0, this.TransactionUsageReason);
                }

                return responseData;
            }
        }

        isProductUsageEnabled(variant: SupplyUsageItem | Meevo.Model.StockLevel): boolean {
            return this.tenantEnableProductUsageTracking && variant.enableProductUsageTracking && variant.productUsageType == ProductUsageAmountTypeEnum.PartialAmount;
        }
    }

    angular.module('meevo.plugins.employeeSupplyUsage')
        .controller('meevo.plugins.employeeSupplyUsage.EmployeeSupplyUsageController', EmployeeSupplyUsageController);
}
